import React, { Component } from 'react';

import { myFn, myConst } from "@/config/";
const { $$ } = myFn;

import "./animate.css";
import "./index.scoped.css";

class Donate extends Component {
    componentDidMount() {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            console.log('', ua);
            $$(".mdui-bottom-nav-active").removeClass("mdui-bottom-nav-active");
            $$(".wechat").trigger("click");
        }
        $$("body").on("click", e => {
            let n = Math.round(Math.random() * 100);
            let $i = "";
            if (n <= 10) $i = $$("<b/>").text("miss");
            else $i = $$("<b/>").text("+1s");
            let x = e.pageX,
                y = e.pageY;
            $i.css({
                "user-select": "none",
                "z-index": 99999,
                top: y + "px",
                left: x + "px",
                position: "fixed",
                color: "#ff5252",
                opacity: 1,
            });
            $i.on(myConst.animationEvent, () => {
                $i.remove();
            });
            $$("body").append($i);
            setTimeout(() => {
                $i.css({
                    animation: "plus 1.5s linear",
                });
            }, 50);
        });
    }

    toggleEwm = seller => {
        switch (seller) {
            case 'alipay':
                document.getElementById("payImg").setAttribute("src", "./static/img/pay_al.png");
                break;
            case 'wechat':
                document.getElementById("payImg").setAttribute("src", "./static/img/pay_wx.png");
                break;
        }
    }

    render() {
        return (
            <div id="donate">
                <div className="mdui-card pay">
                    <div className="mdui-card-header">
                        <img className="mdui-card-header-avatar" src={require("./me.png")} onClick={e => { e.preventDefault(); return false; }} />
                        <div className="mdui-card-header-title">株洲停车查询</div>
                        <div className="mdui-card-header-subtitle">lqzh <span className="love">♥</span></div>
                    </div>
                    <div className="mdui-card-media payWrap">
                        <img src="/static/img/pay_al.png" id="payImg" onClick={() => { return false; }} />
                        <img src="/static/img/pay_wx.png" style={{ display: "none" }} />
                    </div>
                    <div className="mdui-card-content text">如果你觉得这个 WebApp 对你有帮助，可以通过以上二维码为我续 1s。</div>
                </div>

                <div className="nav mdui-bottom-nav ">
                    <a className="mdui-ripple mdui-bottom-nav-active alipay" onClick={e => { e.preventDefault(); this.toggleEwm('alipay'); }}>
                        <i className="mdui-icon material-icons icon iconfont icon-alipay"> </i>
                        <label>支付宝</label>
                    </a>
                    <a className="mdui-ripple wechat" onClick={e => { e.preventDefault(); this.toggleEwm('wechat'); }}>
                        <i className="mdui-icon material-icons icon iconfont icon-custom-wechat"> </i>
                        <label>微信</label>
                    </a>
                </div >
            </div >
        );
    }
}

export default Donate;